var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBuildSkipping = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 22,
  height: 22,
  viewBox: "0 0 22 22"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(2 6)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15 0C14.447 0 14 .448 14 1L14 1.782C12.594.65 10.838 0 9 0 6.399 0 3.949 1.28 2.446 3.425 2.129 3.877 2.238 4.501 2.691 4.818 3.143 5.136 3.767 5.025 4.083 4.573 5.213 2.962 7.051 2 9 2 10.185 2 11.325 2.359 12.294 3L12 3C11.447 3 11 3.448 11 4 11 4.552 11.447 5 12 5L16 5 16 1C16 .448 15.553 0 15 0M10 11L8 11C7.45 11 7 10.55 7 10 7 9.45 7.45 9 8 9L10 9C10.55 9 11 9.45 11 10 11 10.55 10.55 11 10 11"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M4 10C4 8.896 3.104 8 2 8 .896 8 0 8.896 0 10 0 11.104.896 12 2 12 3.104 12 4 11.104 4 10zM18 10C18 8.896 17.104 8 16 8 14.896 8 14 8.896 14 10 14 11.104 14.896 12 16 12 17.104 12 18 11.104 18 10z"
}))));
export default SvgBuildSkipping;